@for (element of sortedIcons$ | async; track element) {
  <div class="container" >
    <ng-container [cdkPortalOutlet]="element"></ng-container>
  </div>
}
